import AES from 'aes-js'
import moment from 'moment'
import Constant from '@/constant'
import Config from '@/config'
import Vue from 'vue'
import Toasted from 'vue-toasted'
import confetti from 'canvas-confetti'
import _filterProfaneWords from 'storybook-utils/profanity-filter/filterProfaneWords'
import store from './store'

Vue.use(Toasted, { duration: 3000, singleton: true })

const getRandomEmoji = () => {
  const numberOfEmojis = Constant.emojis.length
  const randomNumber = Math.floor(Math.random() * numberOfEmojis)

  return Constant.emojis[randomNumber]
}

export default {
  // sample url: http://localhost:8081/a01798ffpr#2 (1-indexed)
  // return a @{number} (0-indexed) from url as currentSlideIndex
  getCurrentSlideIndexFromUrl: () => {
    if (!window.location.hash) return 0
    const id = window.location.hash.replace('#', '')
    return id <= 0 ? 0 : Number(id) - 1
  },

  filterProfaneWords: (text) => {
    return store.state.presentation && store.state.presentation.filteringProfanity
      ? _filterProfaneWords(text)
      : text
  },
  getRandomEmoji,
  gaTrackEvent: (eventCategory, eventAction, eventLabel) => {
    eventCategory = eventCategory || ''
    eventAction = eventAction || ''
    eventLabel = eventLabel || ''
    if (window.ga) {
      window.ga('send', 'event', eventCategory, eventAction, eventLabel)
    }
  },

  gaTrackPageView: (url, title) => {
    if (window.ga) {
      window.ga('send', 'pageview', url, { title })
    }
  },

  getParamValue: (param, url) => {
    if (!url) url = window.location.href
    param = param.replace(/[\\[\]]/g, '\\$&')
    const regex = new RegExp(`[?&]${param}(=([^&#]*)|&|#|$)`)
    const results = regex.exec(url)
    if (!results) return null
    if (!results[2]) return ''
    return decodeURIComponent(results[2].replace(/\+/g, ' '))
  },

  formatSlide: (slide) => {
    if (!slide.SlideOptions) {
      slide.SlideOptions = []
    }
    slide.SlideOptions.sort((a, b) => {
      return a.order - b.order
    })
    for (let i = 0; i < slide.SlideOptions.length; i++) {
      if (
        slide.SlideOptions[i].audience &&
          slide.SlideOptions[i].audience === store.state.audienceId
      ) {
        slide.openEndedSubmited = true
        break
      }
    }

    if (slide.answer && slide.answer.vote.length) {
      [slide.radioSelectded] = slide.answer.vote
    }

    try {
      slide.otherCorrectQuiz = JSON.parse(slide.otherCorrectQuiz)
    } catch (error) {
      slide.otherCorrectQuiz = []
    }

    if (!slide.otherCorrectQuiz) {
      slide.otherCorrectQuiz = []
    }

    return slide
  },

  isURL(str) {
    const pattern = new RegExp(
      '^(https?:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
        '(\\#[-a-z\\d_]*)?$',
      'i',
    ) // fragment locator
    return pattern.test(str)
  },

  timeToString(seconds) {
    // multiply by 1000 because Date() requires miliseconds
    const date = new Date(seconds * 1000)
    let mm = date.getUTCMinutes()
    let ss = date.getSeconds()
    // If you were building a timestamp instead of a duration, you would uncomment the following line to get 12-hour (not 24) time
    // if (hh > 12) {hh = hh % 12;}
    // These lines ensure you have two-digits
    if (mm < 10) {
      mm = `0${mm}`
    }
    if (ss < 10) {
      ss = `0${ss}`
    }
    // This formats your string to HH:MM:SS
    return `${mm}:${ss}`
  },

  checkCorrectAnswer(vote, options) {
    const corrects = []
    let count = 0
    options.forEach((item) => {
      if (item.correct) {
        corrects.push(item.id)
      }
    })
    if (vote.length != corrects.length) {
      return false
    }
    vote.forEach((item) => {
      if (corrects.indexOf(item) !== -1) {
        count++
      }
    })

    if (count && count == corrects.length) {
      return true
    }
    return false
  },

  getTimeCount(seconds, self) {
    const textSeconds = self.$t('seconds')
    const textMinutes = self.$t('minutes')
    const textMinute = self.$t('minute')

    const minutes = Math.floor(seconds / 60)
    const secondsWithinMinute = seconds % 60
    let result = ''

    if (minutes) {
      if (minutes === 1) {
        result += `${minutes} ${textMinute} `
      } else {
        result += `${minutes} ${textMinutes} `
      }
    }

    result += `${secondsWithinMinute.toFixed(2)} ${textSeconds}`

    return result
  },

  getUtcTime() {
    return moment.utc().valueOf()
  },
  setFontSlide(font) {
    const data = Constant.fonts[font]
    const headID = document.getElementsByTagName('head')[0]
    const link = document.createElement('link')
    link.type = 'text/css'
    link.rel = 'stylesheet'

    link.href = data.url
    headID.appendChild(link)
    const newStyle = document.createElement('style')
    newStyle.appendChild(
      document.createTextNode(
        `\
    @font-face {\
        font-family: ${
  data.value
};\
        src: url('${
  data.url
}');\
    }\
    `,
      ),
    )

    document.head.appendChild(newStyle)
    document.body.style.fontFamily = data.value
  },
  getColorByStr(str) {
    const numberOfColors = Constant.colors.length
    const number = str.charCodeAt(0)

    return Constant.colors[number % numberOfColors]
  },
  updateDataQuestionAnswer(arr, tabQnaQuestion) {
    if (tabQnaQuestion === 1) {
      arr.sort((a, b) => {
        return new Date(a.createdAt) - new Date(b.createdAt)
      })
    }

    if (tabQnaQuestion === 2) {
      arr.sort((a, b) => {
        return new Date(b.createdAt) - new Date(a.createdAt)
      })
    }

    if (tabQnaQuestion === 1) {
      arr.sort((a, b) => {
        return b.voteCount - a.voteCount
      })
    }

    if (tabQnaQuestion === 1) {
      arr.sort((a, b) => {
        return b.pinned - a.pinned
      })
    }

    if (tabQnaQuestion === 3) {
      arr.sort((a, b) => {
        return b.answeredTimestamp - a.answeredTimestamp
      })
    }

    arr.forEach((question) => {
      if (question.answered) question.status = 'approved'
      if (question.vote.includes(store.state.audienceId)) {
        question.voted = true
      }
    })

    this._updateQnAQuestionCount(arr)

    store.state.questions = arr
  },

  _updateQnAQuestionCount(questions) {
    const showOtherQuestions = store.state.presentation.qnaAudienceShowAll
    let questionCount = 0
    let questionFilterByShowAll = []
    if (!showOtherQuestions) {
      questionFilterByShowAll = questions.filter((question) => {
        return question.audience === store.state.audienceId
      })
    } else {
      questionFilterByShowAll = questions
    }

    if (store.state.presentation.isModerationMode) {
      questionCount = questionFilterByShowAll.filter((question) => {
        return question.status === 'approved'
      }).length
    } else {
      questionCount = questionFilterByShowAll.filter((question) => {
        return question.status !== 'dismissed'
      }).length
    }
    store.state.questionCount = questionCount
  },

  decrypt(encryptedText, secret) {
    const key = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16]

    // When ready to decrypt the hex string, convert it back to bytes
    const encryptedBytes = AES.utils.hex.toBytes(encryptedText)

    // The counter mode of operation maintains internal state, so to
    // decrypt a new instance must be instantiated.
    // eslint-disable-next-line new-cap
    const aesCtr = new AES.ModeOfOperation.ctr(key, Number(secret))
    const decryptedBytes = aesCtr.decrypt(encryptedBytes)

    // Convert our bytes back into text
    return AES.utils.utf8.fromBytes(decryptedBytes)
  },

  numberWithCommas(number) {
    return number.toLocaleString(store.state.presentation.language)
  },

  hexToRgba(hex, opacity = 1) {
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
      let c = hex.substring(1).split('')
      if (c.length === 3) {
        c = [c[0], c[0], c[1], c[1], c[2], c[2]]
      }
      c = `0x${c.join('')}`
      return `rgba(${[(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',')}, ${opacity})`
    }

    return null
  },

  changeRgbAlpha: (color, opacity) => {
    if (!color) return color
    // eslint-disable-next-line no-useless-escape
    const regex = /[\d\.]+\)$/g
    if (opacity) {
      color = color.replace(regex, opacity)
    }
    return color
  },

  validateEmail: (email) => {
    // eslint-disable-next-line no-useless-escape
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return re.test(String(email).toLowerCase())
  },
  getAhaColor(number) {
    // eslint-disable-next-line
    const index = parseInt(number%(Constant.colors.length - 1))
    return Constant.colors[index]
  },
  checkWhiteLabelDomain() {
    if (window.location.hostname === 'localhost') return false
    return window.location.hostname.indexOf(Config.domain) === -1
  },

  showToastSuccess(text, className, action) {
    if (!text) return
    Vue.toasted.success(text, {
      theme: 'bubble',
      position: 'bottom-right',
      className,
      action: action ? {
        text: '',
        onClick: (e, toastObject) => {
          toastObject.goAway(0)
        },
      } : '',
    })
  },

  setupConfettiEffect(canvasElement, canvasOptions, effectOptions) {
    const effectCreator = confetti.create(canvasElement, canvasOptions)
    return (origin) => {
      effectCreator({
        ...effectOptions,
        origin,
      })
    }
  },

  isIosSafary() {
    try {
      // FIXME: Consider removing this as there should be any
      // reason why we need a specific class for safari.
      // This was added by Loi to fix an issue with safari
      // but we lost track of the original issue. @huongnguyen2152 15.05.2020
      // eslint-disable-next-line
      let isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));
      const ua = window.navigator.userAgent
      const iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i)
      const webkit = !!ua.match(/WebKit/i)
      const iOSSafari = iOS && webkit && !ua.match(/CriOS/i)
      if (isSafari || iOSSafari) {
        return true
      }
      return false
    } catch {
      return false
    }
  },
  formatNumber(number) {
    if (!number) return 0
    if (!store.state.presentation.language) return number
    return parseFloat(number).toLocaleString(store.state.presentation.language)
  },

  abbreviateNumber(number) {
    if (!number) return 0
    if (!store.state.presentation.language) return number
    const oneMillion = 1000000
    if (number > 999 && number < oneMillion) {
      return `${(number / 1000).toFixed(1)}K`
    }
    if (number >= oneMillion) {
      return `${(number / oneMillion).toFixed(1)}M`
    }
    return number
  },

  countNumberOfCorrectAnswers(slideOptions) {
    const allCorrectAnswers = slideOptions.filter((option) => {
      return option.correct === true
    })
    if (!allCorrectAnswers.length) return 0
    return allCorrectAnswers.length
  },
  getDataCorrectAnswers(slideOptions, result) {
    const totalCorrectAnswers = this.countNumberOfCorrectAnswers(slideOptions)
    const allCorrectAnswersIds = []
    slideOptions.forEach((option) => {
      if (option.correct === true) {
        allCorrectAnswersIds.push(option.id)
      }
    })
    const audienceCorrectAnswers = []
    if (result.vote) {
      result.vote.forEach((vote) => {
        if (allCorrectAnswersIds.includes(vote)) {
          audienceCorrectAnswers.push(vote)
        }
      })
    }
    const audienceMissCorrectAnswers = totalCorrectAnswers - audienceCorrectAnswers.length
    return {
      audienceCorrectAnswers,
      audienceMissCorrectAnswers,
      totalCorrectAnswers,
    }
  },
  getSlideType(slideActive) {
    // Because slide type is super confusing (we have 'slideType' & 'type' fields),
    // we need to clarify it here
    if (!slideActive) return ''
    let theTrueSlideType = slideActive.type

    // For quiz-related slide types
    if (slideActive.type === 'pickAnswer') {
      if (slideActive.slideType === 'imageChoice') {
        theTrueSlideType = 'pickImage'
      } else if (slideActive.slideType === 'typeAnswer') {
        theTrueSlideType = 'typeAnswer'
      }
    }

    // Other slide types remains ok
    return theTrueSlideType
  },
  generateButtonCTAURL(presentationID, slideActive, campaign) {
    return `${Config.presenterUrl}/pages/register?source=presentation_${presentationID}&medium=audience_app&campaign=${campaign}&content=${this.getSlideType(slideActive)}`
  },
  trackGAButtonCTA(presentationID, slideActive) {
    this.gaTrackEvent(
      'Audience',
      'Last slide > Button CTA > Opens CTA URL',
      `Presentation ID: ${presentationID}, Slide type: ${this.getSlideType(slideActive)}`,
    )
  },
}
